import type { EditorAPI } from '#packages/editorAPI';

export function isInViewport(
  editorAPI: EditorAPI,
  position: { y: number; height: number },
): boolean {
  const stage = editorAPI.ui.stage.getEditingAreaLayout();

  return position.y > 0 && position.y + position.height < stage.height;
}
